<template lang="pug">
	modal(:max-width="400")
		.card
			.card-header.bg-warning
				span.fa.fa-cube.mr-2
				| Agregar buzón
				button.close(@click="cerrar") &times
			.card-body
				.alert.alert-warning
					b Agregar un buzón
					p Para agregar este buzón es necesario que especifiques el tipo de contenido que hay en él

				select.form-control(v-model="tipo_ID")
					option(:value="null") Selecciona un tipo de contenido
					option(
						v-for="tipo in listadoTipos"
						:key="tipo.ID_tipo"
						:value="tipo.ID_tipo"
					) {{tipo.nombre}}
			.card-footer
				button.btn.btn-primary(@click="asignar")
					span.fa.fa-save.mr-2
					| Asignar
</template>

<script>
export default {
	props: ['idRelleno', 'idBuzon', 'nombreBuzon'],
	data () {
		return {
			tipo_ID: null,
			listadoTipos: []
		}
	},
	created () {
		this.getListadoTipos()
	},
	methods: {
		getListadoTipos () {
			this.$http.get('gestion-emisoras/php/api/emisoras/get-tipos-buzones.php')
				.then(res => {
					this.listadoTipos = res.data.listado
				})
				.catch(this.$responseError)
		},
		asignar () {
			const datos = {
				ID_relleno: this.idRelleno,
				tipo_ID: this.tipo_ID
			}
			this.$http.post('gestion-emisoras/php/api/emisoras/set-buzon.php', datos)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Asignado',
						mensaje: 'Se ha asignado el buzón correctamente'
					})
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/emisoras/agrega-buzon.vue